import { EntityService } from './EntityService';
import { IDGAreaStat } from '../types';

export class DGAreaStatService extends EntityService<IDGAreaStat> {
    public readonly parentEntities = [];
    protected childrenEntities = [];

    constructor() {
        super(`/DGAreaStats`);
    }

    public readAllWithArgs(periodId: number, SPDGAreaStat2: boolean): Promise<IDGAreaStat[]> {
        if (SPDGAreaStat2 === true)
            return this.readAll(`?periodId=${periodId}&SPDGAreaStat2=`);
        else
            return this.readAll(`?periodId=${periodId}`);
    }
}